<h2 mat-dialog-title class="confirmation-title">{{ title }}</h2>

<mat-dialog-content class="mat-typography confirmation-content">
  <p class="confirmation-intro">Confira os dados antes de concluir. Você poderá acompanhar o agendamento na sua agenda.</p>

  <page-alert
    *ngIf="submittedSchedule && !successSchedule"
    [message]="messageError"
    alertClass="alert-danger"
  ></page-alert>
  <page-alert
    *ngIf="submittedSchedule && successSchedule"
    message="Agendamento realizado com sucesso."
    alertClass="alert-success"
  ></page-alert>

  <section class="appointment-highlight" aria-label="Data e horário do agendamento">
    <div class="highlight-icon" aria-hidden="true">
      <mat-icon>event_available</mat-icon>
    </div>
    <div class="highlight-date">
      <span class="eyebrow">{{ isByOrder ? 'ATENDIMENTO POR ORDEM DE CHEGADA' : 'HORÁRIO SELECIONADO' }}</span>
      <strong>{{ datetime | date: 'dd/MM/yyyy' }}</strong>
      <span *ngIf="!isByOrder">às {{ datetime | date: 'HH:mm' }}</span>
      <span *ngIf="isByOrder">Início previsto às {{ byOrderStart | date: 'HH:mm' }}</span>
    </div>
    <div class="highlight-price">
      <span>Valor particular</span>
      <strong>{{ formatPrice(procedure.price_high) }}</strong>
    </div>
  </section>

  <div class="confirmation-grid">
    <section class="summary-card procedure-card" aria-labelledby="procedure-summary-title">
      <div class="section-heading">
        <mat-icon aria-hidden="true">medical_services</mat-icon>
        <h3 id="procedure-summary-title">Procedimento e local</h3>
      </div>

      <p class="procedure-name">{{ friendlyProcedureName(procedure.name) || 'Procedimento' }}</p>

      <div class="detail-row">
        <mat-icon aria-hidden="true">business</mat-icon>
        <div>
          <span class="detail-label">Clínica</span>
          <strong>{{ organization?.name || procedure.organization.name || 'Unidade não informada' }}</strong>
        </div>
      </div>

      <div class="detail-row">
        <mat-icon aria-hidden="true">place</mat-icon>
        <div>
          <span class="detail-label">Endereço</span>
          <strong>{{ getAddress(address) }}</strong>
        </div>
      </div>

      <div class="detail-row">
        <mat-icon aria-hidden="true">person</mat-icon>
        <div>
          <span class="detail-label">Profissional</span>
          <strong>{{ practitioner?.name || 'Não informado' }}</strong>
        </div>
      </div>
    </section>

    <section class="summary-card patient-card" aria-labelledby="patient-summary-title">
      <div class="section-heading">
        <mat-icon aria-hidden="true">account_circle</mat-icon>
        <h3 id="patient-summary-title">Paciente</h3>
      </div>

      <div class="patient-name">{{ patientLogged?.name || 'Paciente' }}</div>
      <div class="detail-row">
        <mat-icon aria-hidden="true">phone</mat-icon>
        <div>
          <span class="detail-label">Telefone para contato</span>
          <strong>{{ formatPhone(contactPhone) || 'Não informado' }}</strong>
        </div>
      </div>
      <p class="patient-note">Confira se seus dados de contato estão atualizados para receber informações sobre o agendamento.</p>
    </section>
  </div>

  <section *ngIf="type === 'Exame' && procedure.extraDetails" class="summary-card exam-guidance">
    <div class="section-heading">
      <mat-icon aria-hidden="true">info</mat-icon>
      <h3>Orientações do exame</h3>
    </div>
    <div class="exam-guidance-content" [innerHTML]="procedure.extraDetails"></div>
  </section>

  <section class="summary-card payment-card" aria-labelledby="payment-summary-title">
    <div class="section-heading">
      <mat-icon aria-hidden="true">payments</mat-icon>
      <h3 id="payment-summary-title">Forma de pagamento</h3>
    </div>

    <p *ngIf="paymentSettingsLoaded && !hasOnlinePaymentMethods" class="payment-notice">
      Esta unidade não configurou pagamento online. O pagamento será feito presencialmente.
    </p>

    <div *ngIf="schedule.scheduling_method === 'PARTICULAR'" class="payment-selection">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Selecione como deseja pagar</mat-label>
        <mat-select [(ngModel)]="schedule.paymentMethod" required>
          <mat-option *ngFor="let method of paymentMethods" [value]="method.name">
            {{ getPaymentMethodLabel(method.name) }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="!isPaymentMethodAvailable(schedule.paymentMethod)">Selecione uma forma de pagamento válida.</mat-error>
      </mat-form-field>
      <p class="payment-caption">A confirmação reserva o agendamento. Se escolher PIX ou cartão, você continuará para o pagamento na próxima etapa.</p>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="confirmation-actions">
  <button mat-button [mat-dialog-close]="false" [disabled]="isSavingSchedule">Voltar</button>
  <button mat-flat-button color="primary" class="confirm-button" (click)="saveSchedule()" [disabled]="!canSaveSchedule()">
    <mat-icon *ngIf="!isSavingSchedule" aria-hidden="true">check</mat-icon>
    {{ isSavingSchedule ? 'Confirmando...' : 'Confirmar agendamento' }}
  </button>
</mat-dialog-actions>
